
import { useState, useEffect, useContext } from "react";
import { get_tiptap_test_data, get_tiptap_doc } from '../../../../services/projectservice.js';
import TipTapEditor from "../tiptap/TipTapEditor";
import { AuthContext } from '../../../../AuthContext.jsx';
import { tiptap_doc_id } from   '../../root/demo/demo_util.js'

export default function DocEditDemo() {

  const { authToken, claims, isLoading, onLogout } = useContext(AuthContext);

    const [ editorContent, setEditorContent ] = useState('');
    const [ loadError, setLoadError ] =  useState(''); 

    const handleLoad = (data) => {
        setEditorContent(data.data); 
    }

    const handleLoadError = (error) => {
        console.error("Error loading data:", error);
        setLoadError(`Error loading data: ${error}`);
    }

    useEffect(() => { 
        get_tiptap_doc(tiptap_doc_id, authToken, handleLoad, handleLoadError)
    }, []);
    
    return (
        <div>
            <h1>Doc Editor Demo</h1> 
            { editorContent && <TipTapEditor initialContent={editorContent} doc_id={tiptap_doc_id} /> }
            { loadError && <div style={{ color: 'red' }}>{loadError}</div>  }
        </div>
    );
}
